// extracted by mini-css-extract-plugin
module.exports = {"formArea":"page-formArea-1lLwd6","dropdownContainer":"page-dropdownContainer-2Ngdcm","submitButtons":"page-submitButtons-3-nMUk"};